import React from 'react';
import Stepper from '../UI/Stepper';
import { MenuScreen } from '../UI/MenuScreen';

export const SteepsToFollow = () => {
    return (
        <div className="home__main ">
            <MenuScreen/>
            <div className="home__howWorks center-center">
                

            <h1 className="home__title3 home__black mt-15">¿Pasos a seguír ?</h1>
            <div className="stepperstyle">
                    
            <Stepper/>
                </div>
            </div>
          
        </div>
    )
}
